import { useEffect, useRef } from "react";

import { clarityProjectId } from "../../config/publicEnv";

/**
 * Microsoft Clarity — același mecanism ca snippet-ul oficial.
 * ID proiect: `REACT_APP_CLARITY_PROJECT_ID` în `.env`.
 * @see https://learn.microsoft.com/en-us/clarity/
 */
const ClarityScript = () => {
  const inserted = useRef(false);

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    const projectId = clarityProjectId;
    if (!projectId || inserted.current) return;
    if (
      document.querySelector('script[src^="https://www.clarity.ms/tag/"]')
    ) {
      inserted.current = true;
      return;
    }
    inserted.current = true;

    (function (
      c: Window,
      l: Document,
      a: string,
      r: string,
      i: string,
    ) {
      // Snippet oficial Clarity — necesită `arguments` în coadă
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const w = c as any;
      w[a] =
        w[a] ||
        function clarityQueue() {
          (w[a].q = w[a].q || []).push(arguments);
        };
      const t = l.createElement(r) as HTMLScriptElement;
      t.async = true;
      t.src = `https://www.clarity.ms/tag/${i}`;
      const y = l.getElementsByTagName(r)[0];
      if (y?.parentNode) {
        y.parentNode.insertBefore(t, y);
      } else {
        l.head.appendChild(t);
      }
    })(window, document, "clarity", "script", projectId);
  }, []);

  return null;
};

export default ClarityScript;
